import { z } from 'zod';

import { ProjectApprovalStatus } from '../enums/project.enum';
import { ApiResponseSchema } from './api.schema';

export const VoterSchema = z.object({
  name: z.string(),
  avatar: z.string(),
});
export const VoteStatusSchema = z.object({
  id: z.string(),
  programId: z.string(),
  status: z.enum([ProjectApprovalStatus.APPROVED, ProjectApprovalStatus.PENDING, ProjectApprovalStatus.REJECTED]),
  voter: VoterSchema,
  voterAddr: z.string(),
});

export const VotingProgramSchema = z.object({
  id: z.string(),
  name: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  url: z.string().optional(),
  nodeSaleUrl: z.string().optional(),
});

export const VotingListItemSchema = z.object({
  id: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  programId: z.string(),
  program: VotingProgramSchema,
  status: z.enum([ProjectApprovalStatus.APPROVED, ProjectApprovalStatus.PENDING, ProjectApprovalStatus.REJECTED]),
  voterAddr: z.string(),
});

export const VotingListSchema = z.array(VotingListItemSchema);

export const VotingListApiResponseSchema = ApiResponseSchema.extend({
  data: VotingListSchema,
});

// export types
export type VotingListItem = z.infer<typeof VotingListItemSchema>;
export type VotingList = z.infer<typeof VotingListSchema>;
export type VotingListApiResponse = z.infer<typeof VotingListApiResponseSchema>;
export type VoteStatus = z.infer<typeof VoteStatusSchema>;
